const A = "https://customer-assets-39nsmqrw.emergentagent.net/job_pacific-logistics/artifacts";

export const IMG = {
  // All authentic WayFinder Pacific / Tuvalu photography
  hero: `${A}/bdhqonnn_485409229_1191110436350163_527153919716322577_n.webp`, // pristine beach
  runway: `${A}/50w68r8m_56_960.jpg`,                                          // Funafuti runway
  causeway: `${A}/p9h1tkgh_DJI_20231223183104_0013_D.webp`,                    // port / causeway aerial
  faleSunset: `${A}/n4hupkk9_20220128_181908.webp`,                           // fale pavilions at sunset
  beachSunset: `${A}/z436ld32_20210830_174751.webp`,                          // beach sunset with boats
  pristineBeach: `${A}/bdhqonnn_485409229_1191110436350163_527153919716322577_n.webp`,
  teAno: `${A}/i947n9pd_470536278_1103027547862302_5053159383205084068_n.webp`, // Te Ano ball game
  roadAtoll: `${A}/7q6nh896_468515817_1089709185860805_737419612601164307_n.webp`, // road through palms
  townAerial: `${A}/zm5g6jhn_468433758_1088723889292668_3696921337294472994_n.jpg`, // town + runway aerial
};

export const SERVICES = [
  { n: "01", title: "Event management", body: "Conferences, government and donor meetings, festivals, weddings and milestones — venue, programme, catering, staging and delegates handled end to end." },
  { n: "02", title: "Accommodation booking", body: "Rooms across hotels, guesthouses and homestays, including group bookings and overflow — with no double-booking surprises." },
  { n: "03", title: "Tours & guiding", body: "Cultural, marine and heritage tours designed and guided by locals, plus full tour-group arrangement from arrival to departure." },
  { n: "04", title: "Logistics & travel", body: "Inter-island flights, boat charters, freight, transfers and itineraries — coordinated as one seamless plan." },
];

export const SEGMENTS = [
  { k: "Governments & agencies", v: "Delegations, summits and official visits run to protocol." },
  { k: "Donors, UN & NGOs", v: "Field missions and multi-stakeholder programmes, coordinated." },
  { k: "Businesses", v: "Off-sites, launches and incentive travel without the logistics headache." },
  { k: "Tourists & tour groups", v: "Set-departure journeys and bespoke island itineraries." },
  { k: "Weddings & private events", v: "Milestones staged on the edge of the ocean." },
];

export const TOURS = [
  { title: "Least-Visited Tuvalu", duration: "7 days", route: "Funafuti → outer atolls → Funafuti", departure: "Departs 14 Sept 2026", img: "roadAtoll" },
  { title: "Three-Nation Moana", duration: "12 days", route: "Fiji → Tuvalu → Marshall Islands", departure: "Departs 03 May 2026", img: "townAerial" },
  { title: "Funafuti Lagoon Escape", duration: "5 days", route: "Funafuti lagoon & conservation area", departure: "Departs 22 June 2026", img: "beachSunset" },
];

export const EVENTS_PLANNING = [
  { title: "Moana Voyage Regatta", body: "A traditional-sail and modern-hull regatta tracing ancestral voyaging routes." },
  { title: "Atoll-to-Atoll Swim & Snorkel", body: "An open-water endurance crossing over living reef, guided by local watermen." },
  { title: "Edge of the World Festival", body: "Music, food and story at the literal edge of the map — where the atoll meets open ocean." },
];

export const STEPS = [
  { n: "01", title: "Tell us the goal", body: "A summit, a wedding, a field mission or a tour — start with the outcome you need." },
  { n: "02", title: "We set the course", body: "We design the route, budget, logistics and programme, then confirm every detail." },
  { n: "03", title: "We run it", body: "On the ground, one accountable local operator handles delegates, transport and staging." },
  { n: "04", title: "You arrive well", body: "You show up, it works, and you leave with the story — not the coordination scars." },
];

export const NEEDS = [
  "Set-departure tour", "The Runway Marathon", "Another event", "Event management",
  "Accommodation", "Tours", "Logistics", "Not sure yet",
];
